import axios from 'axios';
import type { Cell, Node, Row, Section } from '@getaccept/editor-lib';
import { EditorHelper } from '@getaccept/editor-lib';
import type { Document } from '@getaccept/lib-shared/src/types/Document';
import { DocumentPageType } from '@getaccept/lib-shared/src/enums/document-page-type';

export default class TemplateService {
  static async fetch(id: string): Promise<Document> {
    const {
      data: {
        data: { document },
      },
    } = await axios.get(`/signup/get/template/${id}`);
    return {
      name: document.name,
      id,
      type: document.type,
      tags: document.tags,
      video: document.video,
      pages: document.pages.map(page => ({
        id: page.id,
        pageType: page.page_type,
        orderNum: page.order_num,
        cropBoxH: page.cropBoxH,
        cropBoxW: page.cropBoxW,
        pageWidth: page.page_width,
        pageHeight: page.page_height,
        thumbUrl: page.thumb_url,
        contentLinkBlock:
          page.page_type !== DocumentPageType.ContentLink
            ? null
            : {
                title: page.title,
                description: page.description,
                url: page.url,
                buttonText: page.buttonText,
                thumbExtension: page.thumbExtension,
                thumbUrl: page.thumbUrl,
                id: page.id,
              },
        video:
          page.page_type !== DocumentPageType.Video
            ? null
            : {
                thumbUrl: page.thumbUrl,
                videoUrl: page.videoUrl,
                videoTitle: page.videoTitle,
                videoType: page.videoType,
                id: page.id,
              },
        editorBlock:
          page.page_type !== DocumentPageType.Editor
            ? null
            : {
                content: {
                  id: page.id,
                  sections: page.content.sections.map((section: Section) => ({
                    id: section.id,
                    rows: section.rows.map((row: Row) => ({
                      id: row.id,
                      type: row.type,
                      cells: row.cells.map((cell: Cell) => ({
                        id: cell.id,
                        type: cell.type,
                        width: cell.width,
                        nodes: cell.nodes.map((node: Node) =>
                          EditorHelper.getNewNode({
                            ...node,
                            nodeId: node.id,
                            nodeType: node.type,
                          })
                        ),
                      })),
                    })),
                  })),
                },
              },
      })),
    };
  }
}
